export default {
   "common.popup.usePromoCode": "Use the promo code: {code}",
   "common.rooms.promotion.offer": "{quantity, plural, one {Special offer} other {Special offers}}",
   "common.rooms.promotion.code": "Promotion code",
   "common.rooms.promotion.minors.free": "{quantity, plural, =0 {All minors free} =1 {# free minor} other {# free minors}}",
   "common.promotion.night.free": "{quantity, plural, =1 {1st night free every {days} days} =2 {2nd night free every {days} days}other {#th night free every {days} days}}",
   "common.rooms.promotion.off": "off",
   "common.promotion.buttonText": "Book now",
}